/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeResponse
 */
export interface StripeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StripeResponse
     */
    received?: boolean;
}

/**
 * Check if a given object implements the StripeResponse interface.
 */
export function instanceOfStripeResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StripeResponseFromJSON(json: any): StripeResponse {
    return StripeResponseFromJSONTyped(json, false);
}

export function StripeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'received': !exists(json, 'received') ? undefined : json['received'],
    };
}

export function StripeResponseToJSON(value?: StripeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'received': value.received,
    };
}

